module.exports = {
  setUser: () => {},
};
